export enum HealthPassportRoutesEnum {
  ROOT = "/health-passport",
  "HEALTH_CONDITION_HISTORY" = "/health-passport/health-condition-history",
  "MEDICATION_HISTORY" = "/health-passport/medication-history",
  "PRESCRIPTION_HISTORY" = "/health-passport/prescription-history",
  "EYE_EXAM_HISTORY" = "/health-passport/eye-exam-history",
  "FOOT_EXAM_HISTORY" = "/health-passport/foot-exam-history",
  "MY_LABS_HISTORY" = "/health-passport/my-labs-history",
  "MY_PROVIDER_HISTORY" = "/health-passport/my-provider-history",
  "MY_PHARMACY_HISTORY" = "/health-passport/my-pharmacy-history",
  "PAST_MEDICAL_PROCEDURE_HISTORY" = "/health-passport/past-medical-procedure-history",
}

export enum HealthPassportPathsEnum {
  ROOT = "health-passport",
  HEALTH_CONDITION_HISTORY = "health-condition-history",
  MEDICATION_HISTORY = "medication-history",
  PRESCRIPTION_HISTORY = "prescription-history",
  PRESCRIPTION__DETAILS = "prescription-history/:id",
  EYE_EXAM_HISTORY = "eye-exam-history",
  FOOT_EXAM_HISTORY = "foot-exam-history",
  MY_LABS_HISTORY = "my-labs-history",
  MY_PROVIDER_HISTORY = "my-provider-history",
  MY_PHARMACY_HISTORY = "my-pharmacy-history",
  PAST_MEDICAL_PROCEDURE_HISTORY = "past-medical-procedure-history",
}
